import axiosClient from '../../configs/axios';


class PlantMasterService {
    // Get list 
    async getPlantList(params) {
        try {
            const response = await axiosClient.get(
                `/unit/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addPlant(data) {
        try {
            const response = await axiosClient.post('/unit/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeletePlant(data) {
        try {
            const response = await axiosClient.put(`/unit/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new PlantMasterService(); 